import * as React from 'react';
import App from './App';

interface Props {
  contextData: object;
  conversationSummary: any;
  conversationSentiments: {
    [contactId: string]: string;
  };
  conversationSentimentLoading: {
    [contactId: string]: boolean;
  };
  agentPath: Array<{ DisplayName: string; ContactId: string; ParticipantId: string }> | string;
  enableSummary: boolean;
  sentimentEnabled: boolean;
  trendLineData: any;
  callBackEvent: (event: any, eventData: object) => void;
  darkMode: boolean;
  CIP: boolean;
  language: string;
  feedback: any;
  urls: {
    HENDRIX_DOMAIN: string;
    CM_DOMAIN: string;
    CIP_DOMAIN: string;
    CCP_API_END_POINT: string;
    RTS_PROCESSOR_ENDPOINT: string;
  };
}

export const LibraryModule = ({
  contextData,
  conversationSummary,
  conversationSentiments,
  conversationSentimentLoading,
  agentPath,
  enableSummary,
  sentimentEnabled,
  trendLineData,
  callBackEvent,
  darkMode,
  CIP,
  language,
  urls,
  feedback,
}: Props) => {
  return (
    <App
      contextData={contextData}
      feedback={feedback}
      conversationSummary={conversationSummary}
      conversationSentiments={conversationSentiments}
      conversationSentimentLoading={conversationSentimentLoading}
      agentPath={agentPath}
      enableSummary={enableSummary}
      sentimentEnabled={sentimentEnabled}
      trendLineData={trendLineData}
      callBackEvent={callBackEvent}
      darkMode={darkMode}
      CIP={CIP}
      language={language}
      urls={urls}
    />
  );
};
